import { useEffect, useRef } from 'react';
import { subscribeScroll } from '../scroll/scrollStore.js';

export function ProgressBar() {
  const ref = useRef(null);

  useEffect(
    () =>
      subscribeScroll((snap) => {
        if (ref.current) ref.current.style.width = `${(snap.progress * 100).toFixed(2)}%`;
      }),
    [],
  );

  return <div className="progress-bar" ref={ref} aria-hidden="true" />;
}
